import { multiCityFormConfig } from './multi-city';
import { passengersConfig } from './passengers';

export const searchFormConfig = {
  ...passengersConfig,
  ...multiCityFormConfig,
};
